<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAdd" />
    <div class="serType">
      <van-dropdown-menu class="serTypeBar" active-color="#E32119">
        <van-dropdown-item v-model="search.isAsc" :options="optionSort" @change="selectTypeClose" />
        <van-dropdown-item v-model="search.state" :options="optionState" @change="selectTypeClose" />
      </van-dropdown-menu>
    </div>
    <div class="listBody">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.userTextbookId" class="textbooks">
          <van-row>
            <van-col span="12">课程:{{ item.courseName }}</van-col>
            <van-col span="12" class="textRight">{{ GetEnumText('Em_TextbookType',item.state) }}</van-col>
          </van-row>
          <van-row>
            <van-col span="14"> 申请时间:{{ formatDate(item.createTime,"yyyy-MM-dd hh:mm:ss",true) }}</van-col>
            <van-col v-if="item.state =='REG'" span="10" class="textRight mainColor"><span @click="onLookteachingProgress(item.userTextbookId)">查看教学进度</span></van-col>
          </van-row>
          申请备注:{{ item.remark }}
          <van-row v-if="item.user">
            <van-col span="12">学员:{{ item.user.firstName }} {{ item.user.lastName }}
              <br>
              邮箱:{{ item.user.email }}
            </van-col>
            <van-col span="12">生日:{{ formatDate(item.user.birthday,"yyyy-MM-dd") }}<br>
              性别:{{ item.user.sex }}</van-col>
          </van-row>
          <div v-if="item.state =='CANCEL'">取消原因:{{ item.verifyRemark }}</div>
          <div v-if="item.state =='REG' || item.state =='CANCEL'">审核时间:{{ formatDate(item.regTime,"yyyy-MM-dd hh:mm:ss",true) }}</div>
          <div v-if="item.state =='REG'">注册号:{{ item.REGISTRATIONID }}</div>
        </div>
      </van-list>
    </div>
  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, GetEnumText } from '@/utils/base'
import { DropdownMenu, DropdownItem, List, Button } from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '教学教材申请列表',
      backurl: '/users/index',
      list: [],
      loading: false,
      finished: false,
      search: {
        isAsc: false,
        limit: 30,
        page: 1,
        state: undefined
      },
      optionSort: [
        { text: '正序', value: true },
        { text: '倒序', value: false }
      ],
      optionState: [
        { text: '不限', value: undefined },
        { text: '申请', value: 'APPLY' },
        { text: '注册中', value: 'REGING' },
        { text: '已注册', value: 'REG' },
        { text: '取消', value: 'CANCEL' }
      ]
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.list = []
    this.onLoad()
  },
  methods: {
    formatDate,
    GetEnumText,
    onAdd() {
      this.$router.replace('/textbook/applicationTextbook')
    },
    selectTypeClose() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLookteachingProgress(id) {
      this.$router.replace('/textbook/teachingProgressOne/' + id + '?backurl=/textbook/applicationTextbookList')
    },
    onLoad() {
      this.loading = true
      request({
        url: '/Course/getProUserTextbook',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.serType{
  position: fixed;
  left: 0;
  top: 3em;
  right: 0;
  height: 2em;
}
.listBody{
   margin-top: 3.8em;

}
.textbooks{
  margin-top: 0.8em;
  font-size: 0.9em;
  line-height: 1.6em;
  padding: 0.5em 1em;
  background-color: #fff;
  border-top: 1px solid #ddd;
}
</style>
